<template>
  <div>
    <modal
      name="report-modal"
      height="auto"
      classes="report-modal-wrapper"
      style="z-index: 1050; display: flex; align-items: center; justify-content: center; height: 100%"
      scrollable
      @before-close="beforeClose"
    >
      <div class="modal-box d-flex justify-content-center align-items-center">
        <div class="modal-box-inner">
          <div v-if="step === 1" class="modal-box-body">
            <p class="text-xl bold mb-3">運営に報告する</p>
            <p>
              投稿内容が以下に当てはまる場合は、運営に報告をお願いします。
              <br class="pc" />
              運営にて内容を確認し、削除等の対応を行います。
            </p>
            <ul class="report-list">
              <li class="d-flex align-items-center">
                <div class="report-icon">
                  <svg viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_171_9)">
                      <path
                        d="M18 19C13.5176 19 10 14.2809 10 8.26509C10 0.802693 15.598 0 18 0C20.402 0 26 0.802693 26 8.26509C26 14.2897 22.4824 19 18 19ZM18 1.66713C15.2161 1.66713 11.8995 2.81383 11.8995 8.26509C11.8995 13.1871 14.6935 17.3417 18 17.3417C21.3065 17.3417 24.1005 13.1871 24.1005 8.26509C24.1005 2.81383 20.7839 1.66713 18 1.66713Z"
                        fill="#AC9890"
                      />
                      <path
                        d="M33.23 33.38C32.71 33.38 32.29 32.96 32.29 32.44V30.78C32.29 30.59 32.17 30.41 31.98 30.35C30.48 29.82 29.48 28.4 29.48 26.83C29.48 24.76 31.16 23.08 33.23 23.08C35.3 23.08 36.98 24.76 36.98 26.83C36.98 28.4 35.97 29.82 34.48 30.35C34.3 30.42 34.17 30.59 34.17 30.78V32.44C34.17 32.96 33.75 33.38 33.23 33.38ZM33.23 24.96C32.2 24.96 31.37 25.8 31.37 26.82C31.37 27.84 32.21 28.68 33.23 28.68C34.25 28.68 35.09 27.84 35.09 26.82C35.09 25.8 34.25 24.96 33.23 24.96Z"
                        fill="#AC9890"
                      />
                      <path
                        d="M43.0574 19.02H40.2474C39.9974 19.02 39.7874 18.81 39.7874 18.56C39.7874 14.94 36.8474 12 33.2274 12C29.6074 12 26.6674 14.94 26.6674 18.56C26.6674 18.81 26.4574 19.02 26.2074 19.02H23.3974C22.8774 19.02 22.4574 19.44 22.4574 19.96V28.38C22.4574 32.07 24.3174 35.32 27.1474 37.26H9.42741C9.17741 37.26 8.96741 37.05 8.96741 36.8V31.18C8.96741 30.66 8.54741 30.24 8.02741 30.24C7.50741 30.24 7.08741 30.66 7.08741 31.18V36.8C7.08741 37.05 6.87741 37.26 6.62741 37.26H2.36741C2.11741 37.26 1.91741 37.06 1.90741 36.81C1.75741 32.23 2.21741 26.2 4.01741 24.27C4.49741 23.75 4.93741 23.7 5.22741 23.7L13 23C15 22.5 13.9661 20.7068 12.5 21C10 21.5 8.02741 21.83 5.5 21.83H5.21741C4.24741 21.83 3.34741 22.23 2.62741 23C-0.59259 26.46 0.01741 37.08 0.09741 38.28C0.12741 38.77 0.54741 39.16 1.03741 39.16H33.4074C33.4074 39.16 33.4474 39.15 33.4674 39.15C39.2974 39.03 44.0074 34.25 44.0074 28.39V19.97C44.0074 19.45 43.5874 19.03 43.0674 19.03L43.0574 19.02ZM33.2374 13.89C35.8174 13.89 37.9074 15.99 37.9074 18.56C37.9074 18.81 37.6974 19.02 37.4474 19.02H29.0274C28.7774 19.02 28.5674 18.81 28.5674 18.56C28.5674 15.98 30.6674 13.89 33.2374 13.89ZM42.1174 28.39C42.1174 33.29 38.1374 37.27 33.2374 37.27C28.3374 37.27 24.3574 33.28 24.3574 28.39V21.37C24.3574 21.12 24.5674 20.91 24.8174 20.91H41.6574C41.9074 20.91 42.1174 21.12 42.1174 21.37V28.39Z"
                        fill="#AC9890"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_171_9">
                        <rect width="44" height="40" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p class="report-list-text bold">
                  他の会員のプライバシー（例：実名や滞在予定などの情報）を
                  <br class="pc" />
                  公開する投稿
                </p>
              </li>
              <li class="d-flex align-items-center">
                <div class="report-icon">
                  <svg viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.95931 17.9459C4.95931 17.9459 4.94897 17.956 4.94897 17.961C4.86623 18.0465 4.78867 18.1321 4.71628 18.2176C4.03889 19.0327 3.96132 20.4013 4.01303 21.0503C4.03889 23.4553 6.42268 24.9346 8.12909 24.9346L14.872 24.9346L14.872 31.6968C14.872 32.7031 14.8927 33.7446 15.2029 34.434C15.446 34.9824 15.7821 35.4704 16.2009 35.888C17.08 36.7736 18.2848 37.1711 19.4224 36.9446C20.5186 36.7283 21.3046 36.1245 21.7648 35.1535C22.1423 34.3484 22.1526 33.4579 22.163 32.6729C22.163 32.3459 22.1682 32.0189 22.2044 31.717C22.2147 31.6365 22.225 31.5057 22.2354 31.3195C22.5405 26.7761 23.766 23.5862 25.8654 21.8402C27.0702 20.839 28.6008 20.3711 30.3899 20.3811L30.3899 21.3723C30.3899 22.4994 31.3207 23.4101 32.4635 23.4101L37.9291 23.4101C39.0719 23.4101 40.0027 22.4943 40.0027 21.3723L40.0027 6.03773C40.0027 4.91069 39.0719 4 37.9291 4L32.4583 4C31.3155 4 30.3848 4.91572 30.3848 6.03773L30.3848 18.5748C28.1406 18.5648 26.2067 19.1685 24.6502 20.4616C22.1526 22.5346 20.7151 26.1472 20.3738 31.1987L20.3532 31.5057C20.3118 31.8629 20.3015 32.2503 20.2963 32.6428C20.2911 33.2818 20.2808 33.9409 20.0636 34.3937C19.8568 34.8314 19.5568 35.0629 19.0501 35.1585C18.5433 35.2591 17.9745 35.0528 17.535 34.6151C17.2765 34.3535 17.0645 34.0465 16.9093 33.6943C16.7283 33.2968 16.7335 32.1698 16.7335 31.561L16.7335 24.0138C16.7335 23.5157 16.3147 23.1082 15.8027 23.1082L8.12909 23.1082C7.23452 23.1082 5.88491 22.2729 5.86939 21.0101C5.86939 20.9799 5.86939 20.9497 5.86939 20.9195C5.86939 20.8994 5.8694 20.8792 5.86422 20.8591C5.82286 20.3157 5.96764 19.5811 6.16414 19.3446L6.31927 19.1736C6.47439 19.0075 6.67089 18.7962 6.82084 18.5195C7.12593 17.9358 6.88807 17.3119 6.48991 16.9094C6.36581 16.7182 6.24687 16.5019 6.22102 16.4214C6.14862 16.1698 6.29341 15.7069 7.42067 14.917C7.68956 14.7308 8.06187 14.4239 8.22734 13.9409C8.44969 13.2868 8.1446 12.7535 7.95845 12.4415C7.91708 12.3761 7.8602 12.2755 7.84986 12.2402C7.75678 11.9233 7.91191 11.4453 8.38246 11.244C8.57896 11.1736 8.84268 11.078 9.09088 10.8667C9.56661 10.4541 9.71139 9.81006 9.47353 9.15094C9.41665 8.99496 9.33909 8.84905 9.26152 8.69811C9.22016 8.62263 9.1581 8.51194 9.15293 8.47169C9.12191 8.24024 9.20982 7.58616 9.28738 7.43521C9.54593 7.12326 10.6525 6.81634 11.5109 6.81131L31.1052 6.81131C31.6172 6.81131 32.036 6.40377 32.036 5.90566C32.036 5.40754 31.6172 5 31.1052 5L11.5057 4.99999C10.6111 4.99999 8.69272 5.27672 7.84469 6.28804C7.31726 6.91697 7.24486 8.25031 7.30174 8.69308C7.34828 9.04528 7.49824 9.33207 7.612 9.53836C7.61717 9.55345 7.62751 9.56855 7.63268 9.57861C7.5758 9.59873 7.52409 9.61886 7.47238 9.64402C6.32961 10.1522 5.70392 11.5006 6.05555 12.7233C6.12277 12.9648 6.2417 13.166 6.33478 13.322C6.35029 13.3472 6.36581 13.3774 6.38132 13.4075C6.36581 13.4176 6.35029 13.4327 6.32444 13.4478C5.72461 13.8704 3.8941 15.1535 4.43188 16.9346C4.54046 17.2918 4.83004 17.7597 4.94897 17.9409L4.95931 17.9459ZM32.2463 6.04779C32.2463 5.92201 32.3394 5.82138 32.4583 5.82138L37.9291 5.82138C38.0481 5.82138 38.1412 5.92201 38.1412 6.04779L38.1412 21.3824C38.1412 21.5082 38.0481 21.6088 37.9291 21.6088L32.4583 21.6088C32.3394 21.6088 32.2463 21.5082 32.2463 21.3824L32.2463 6.04779Z"
                      fill="#AC9890"
                    />
                  </svg>
                </div>
                <p class="report-list-text bold">
                  特定の個人、企業、国・地域を
                  <br />
                  不当に評価する投稿
                </p>
              </li>
              <li class="d-flex align-items-center">
                <div class="report-icon">
                  <svg viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M31.2414 36.1379H8.58103C8.18793 36.1379 7.86207 35.8172 7.86207 35.419V4.58103C7.86207 4.18793 8.18276 3.86207 8.58103 3.86207H33.2121C33.6052 3.86207 33.931 4.18276 33.931 4.58103V9.13793C33.931 9.65 34.35 10.069 34.8621 10.069C35.3741 10.069 35.7931 9.65 35.7931 9.13793V4.58103C35.7931 3.15862 34.6345 2 33.2121 2H8.58103C7.15862 2 6 3.15862 6 4.58103V35.419C6 36.8414 7.15862 38 8.58103 38H31.2414C31.7534 38 32.1724 37.581 32.1724 37.069C32.1724 36.5569 31.7534 36.1379 31.2414 36.1379Z"
                      fill="#AC9890"
                    />
                    <path
                      d="M34.8621 29.931C34.35 29.931 33.931 30.35 33.931 30.8621V35.419C33.931 35.8121 33.6103 36.1379 33.2121 36.1379H28.6552C28.1431 36.1379 27.7241 36.5569 27.7241 37.069C27.7241 37.581 28.1431 38 28.6552 38H33.2121C34.6345 38 35.7931 36.8414 35.7931 35.419V30.8621C35.7931 30.35 35.3741 29.931 34.8621 29.931Z"
                      fill="#AC9890"
                    />
                    <path
                      d="M28.0345 16.8965C28.0345 16.3845 27.6156 15.9655 27.1035 15.9655H12.8966C12.3845 15.9655 11.9656 16.3845 11.9656 16.8965C11.9656 17.4086 12.3845 17.8276 12.8966 17.8276H27.1035C27.6156 17.8276 28.0345 17.4086 28.0345 16.8965Z"
                      fill="#AC9890"
                    />
                    <path
                      d="M12.7931 11.6207H24C24.5121 11.6207 24.931 11.2017 24.931 10.6896C24.931 10.1776 24.5121 9.75861 24 9.75861H12.7931C12.281 9.75861 11.8621 10.1776 11.8621 10.6896C11.8621 11.2017 12.281 11.6207 12.7931 11.6207Z"
                      fill="#AC9890"
                    />
                    <path
                      d="M13.1379 24.0345H20.8966C21.4086 24.0345 21.8276 23.6155 21.8276 23.1035C21.8276 22.5914 21.4086 22.1724 20.8966 22.1724H13.1379C12.6259 22.1724 12.2069 22.5914 12.2069 23.1035C12.2069 23.6155 12.6259 24.0345 13.1379 24.0345Z"
                      fill="#AC9890"
                    />
                    <path
                      d="M16.2414 28.3793H13.1379C12.6259 28.3793 12.2069 28.7983 12.2069 29.3103C12.2069 29.8224 12.6259 30.2414 13.1379 30.2414H16.2414C16.7535 30.2414 17.1724 29.8224 17.1724 29.3103C17.1724 28.7983 16.7535 28.3793 16.2414 28.3793Z"
                      fill="#AC9890"
                    />
                    <path
                      d="M43.7258 15.7914L39.0706 11.1362C38.7086 10.7741 38.1189 10.7741 37.7568 11.1362L23.7913 25.1017C23.6724 25.2207 23.5844 25.3707 23.5482 25.5362L21.9965 31.7431C21.9189 32.0586 22.012 32.3948 22.2396 32.6276C22.4155 32.8034 22.6534 32.9017 22.8965 32.9017C22.9741 32.9017 23.0465 32.8914 23.1241 32.8759L29.331 31.3241C29.4965 31.2828 29.6465 31.2 29.7603 31.081L43.7258 17.1155C44.0879 16.7534 44.0879 16.1638 43.7258 15.7966V15.7914ZM28.6275 29.5759L24.1741 30.6879L25.2861 26.2345L27.1482 24.3724L30.4844 27.7086L28.6224 29.5707L28.6275 29.5759ZM31.8086 26.3948L28.4724 23.0586L38.4189 13.1121L41.7551 16.4483L31.8086 26.3948Z"
                      fill="#AC9890"
                    />
                  </svg>
                </div>
                <p class="report-list-text bold">
                  誤った情報を広め、
                  <br />
                  混乱を招く可能性がある投稿
                </p>
              </li>
            </ul>
            <p class="text-sub mb-4">
              その他、著作権や肖像権を侵害する投稿、犯罪的行為やそれにつながる可能性がある投稿、
              ADDressと無関係の商業活動や営利を目的とした投稿、政治・宗教的な活動に関わる投稿、
              <a href="/terms" class="btn-text2 text-normal underline" target="_blank" rel="noopener">ADDressの利用規約</a>
              に違反する投稿
            </p>
            <form>
              <p class="bold">内容</p>
              <div class="form-textarea">
                <textarea v-model="content" class="form-control report-textarea" :class="{ 'is-invalid': errorMessage }" />
              </div>
              <p v-if="!!errorMessage" class="text-red text-center mt-3">{{ errorMessage }}</p>
              <div class="mt-4">
                <button class="btn btn-single btn-primary" @click.prevent="submit">確認画面へ</button>
              </div>
            </form>
            <div class="modal-box-close">
              <button @click.prevent="$modal.hide('report-modal')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#67635e"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="step === 2" class="modal-box-body">
            <p class="text-xl bold mb-3">以下の内容で報告します</p>
            <form>
              <p class="bold">報告内容</p>
              <p class="text-sub mb-4 with-breakline">{{ content }}</p>
              <div class="mt-4">
                <button class="btn btn-single btn-primary" @click.prevent="confirm">報告する</button>
              </div>
              <div class="mt-3 text-center">
                <button class="btn btn-text2" @click.prevent="step = 1">入力画面に戻る</button>
              </div>
            </form>
            <div class="modal-box-close">
              <button @click.prevent="$modal.hide('report-modal')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#67635e"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="step === 3" class="modal-box-body">
            <p class="text-xl bold mb-3">報告ありがとうございます</p>
            <form>
              <p>ADDressコミュニティの安全性向上に役立たせていただきます。</p>
              <div class="mt-4">
                <button class="btn btn-single btn-white" @click.prevent="$modal.hide('report-modal')">閉じる</button>
              </div>
            </form>
            <div class="modal-box-close">
              <button @click.prevent="$modal.hide('report-modal')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#67635e"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      content: '',
      errorMessage: null,
      step: 1,
      modalReportType: null,
      modalReportId: null,
      modalReportApiUrl: null,
    }
  },
  async mounted() {
    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  methods: {
    beforeClose() {
      this.content = ''
      this.errorMessage = null
      this.step = 1
    },
    submit() {
      if (this.validateContent()) {
        this.step = 2
      }
    },
    async confirm() {
      if (!this.validateContent()) {
        this.step = 1
        return
      }

      await axios
        .post(this.modalReportApiUrl, {
          report: {
            reportable_id: this.modalReportId,
            reportable_type: this.modalReportType,
            content: this.content,
          },
        })
        .then(() => {
          this.step = 3
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message
          this.step = 1
        })
    },
    validateContent() {
      if (this.content.length > 2000) {
        this.errorMessage = '報告内容は2000文字以内で入力してください'
        return false
      } else if (this.content.length < 1) {
        this.errorMessage = '報告内容を入力してください'
        return false
      }

      this.errorMessage = null
      return true
    },
    openWithInfo(info) {
      this.modalReportType = info.reportType
      this.modalReportId = info.reportId
      this.modalReportApiUrl = info.reportApiUrl
      this.$modal.show('report-modal')
    },
  },
}
</script>

<style lang="scss">
.vm--modal.report-modal-wrapper {
  top: initial !important;
  left: initial !important;
  width: initial !important;
  height: initial !important;
}

.with-breakline {
  white-space: pre-wrap;
}
</style>
